const paymentMethodsMap = {
  stripe: 'stripe',
  paypal: 'paypal',
  bacs: 'bacs',
  cod: 'cod',
  other: 'other',
  unset: '',
}
export default paymentMethodsMap
